import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(0),
    width: "100%",
    height: ({ vhUpdated }) => vhUpdated * 95,
    margin: "auto auto",
    outline: " none",
    "& .MuiDialog-container": {
      width: "100%",
      backgroundColor: "transparent"
    },
    "& .MuiPaper-root": {
      backgroundColor: "transparent"
    }
  },

  paper: {
    display: "flex",
    width: "100%",
    height: "100%",
    boxShadow: theme.shadows[2],
    borderTopLeftRadius: theme.spacing(1.5),
    borderTopRightRadius: theme.spacing(1.5),
    background: theme.palette.background.defaultGradient
  },
  card: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(2),
    minHeight: "100%",
    minWidth: "100%",
    backgroundColor: theme.palette.background.defaultGradient,
    overflow: "scroll"
  },
  action: {
    margin: theme.spacing(0)
  },
  header: {
    padding: theme.spacing(0),
    display: "flex",
    alignItems: "center"
  },
  cardContent: {
    padding: theme.spacing(4, 1)
  },
  titleClass: {
    width: "50%",
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.jamii.darkAccent,
    backgroundImage: "linear-gradient(120deg, #F4B793 0%, #F4B793 100%)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 0.2em",
    backgroundPosition: "0 88%",
    transition: "background-size 0.25s ease-in"
  },

  closeText: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main
  },
  closeButton: {
    padding: theme.spacing(1),
    color: theme.palette.jamii.darkAccent
  }
}));
